import { useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import styles from './styles.module.css';
import AdminToolIcon from '@/assets/icons/admintool-icon.svg?react';
import Arrow from '@/assets/icons/arrow.svg?react';
// import BellIcon from '@/assets/icons/bell.svg?react';
import ExternalIcon from '@/assets/icons/external.svg?react';
// import LockIcon from '@/assets/icons/lock.svg?react';
// import OpticsIcon from '@/assets/icons/Optics-icon.svg?react';
import UserIcon from '@/assets/icons/user.svg?react';
// import UserIcon2 from '@/assets/icons/user2.svg?react';
import { APP_VERSION } from '@/constants';
import { PermissionsList } from '@/constants/permissionsList';
import DrawerContext from '@/context/DrawerContext/DrawerContext';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { signOutRedirect } from '@/oidcConfig';
import { clearOnLogOut } from '@/slices/authSlice';
import { RootState } from '@/store';

const NavigationMenu = () => {
  const drawerCtx = useContext(DrawerContext);
  const dispatch = useAppDispatch();
  const auth = useAuth();
  const authState = useSelector((state: RootState) => state.auth);
  const auditableElements = useSelector(
    (state: RootState) => state.auditableElements?.authorizations?.permissions
  ) as PermissionsList;
  const isOidcClient = authState.isOidcClient;
  const navigate = useNavigate();

  const userProfile = useSelector((state: RootState) => state.userProfile);
  const name =
    userProfile?.name ||
    userProfile?.customAtributes?.name ||
    userProfile?.username ||
    'Pulse User';
  const userEmail = userProfile?.email;

  const menuItems = [
    /*     {
      icon: <UserIcon2 />,
      text: 'User Profile',
      onClick: () => {}
    }, */
    /*     {
      icon: <BellIcon />,
      text: 'Subscription Settings',
      onClick: () => { }
    }, */
    /*     {
      icon: <LockIcon />,
      text: 'Change Password',
      onClick: () => { }
    }, */
    {
      icon: <AdminToolIcon />,
      text: 'Admin Tool',
      onClick: () => navigate('/admin-tool'),
      isAllowed: auditableElements?.['ADMIN_TOOL'],
      external: false
    }
    /*     {
      icon: <OpticsIcon />,
      text: 'Go to Optics App',
      onClick: () => { },
      external: true
    } */
  ];

  const onLogout = () => {
    if (isOidcClient) {
      try {
        const idToken = auth?.user?.id_token;
        const email = auth?.user?.profile?.email;

        auth.signoutSilent({
          id_token_hint: idToken
        });
        dispatch(clearOnLogOut());
        localStorage.clear();
        signOutRedirect(idToken, email);
      } catch (error) {
        console.error('Error signing out:', error);
      }
      return;
    }

    dispatch(clearOnLogOut());
    window.location.href = '/login';
  };

  return (
    <div className={styles.drawerContent}>
      <div className={styles.drawerHeader}>
        <button
          className={styles.backButton}
          onClick={() => drawerCtx.closeDrawer()}
        >
          <Arrow className={styles.arrowIcon} width={20} height={20} />
        </button>
        <div className={styles.userInfo}>
          <h3 className={styles.userName}>{name}</h3>
          <p className={styles.userEmail}>{userEmail}</p>
        </div>
        <div className={styles.userAvatar}>
          <UserIcon />
        </div>
      </div>

      <div className={styles.menuOptions}>
        {menuItems.map(
          (item, index) =>
            item.isAllowed && (
              <button
                className={styles.menuItem}
                key={index}
                onClick={() => item.onClick()}
              >
                <div className={styles.menuItemIcon}>{item.icon}</div>
                <span className={styles.menuItemText}>{item.text}</span>
                {item?.external && (
                  <ExternalIcon className={styles.externalIcon} />
                )}
              </button>
            )
        )}
      </div>

      <div className={styles.drawerFooter}>
        <button className={styles.logoutButton} onClick={onLogout}>
          LOGOUT
        </button>
        <div className={styles.versionInfo}>
          Solaris Power 2025 v{APP_VERSION}
        </div>
      </div>
    </div>
  );
};

export default NavigationMenu;
